import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { ImpNoticeComponent } from '../../../imp-notice/imp-notice.component';
import { MapfreModalComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MapfreLoadingComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ModalOptions,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { DataLayerService } from '@services/data-layer/data-layer.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, MapfreModalComponent, ImpNoticeComponent, MapfreButtonComponent],
  selector: 'app-autopay-unenrolled-preconfirm',
  templateUrl: './autopay-unenrolled-preconfirm.component.html',
  styleUrls: ['./autopay-unenrolled-preconfirm.component.css'],
})
export class AutopayUnenrolledPreconfirmComponent implements OnInit{
  @Input() policy: any;
  @Input() action = "unenroll";
  @Output() unenrollEvent: EventEmitter<boolean> = new EventEmitter();
  unEnrollModalOptions: ModalOptions;
  modalIcon: string;
  hideModal: boolean;
  isAcmic: boolean;
  loading = false;

  constructor(
    private acmicService: AcmicService,
    private dataLayer: DataLayerService
  ) {}

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    const btnClass = (this.action === 'unenroll') ?" unenroll-ap-btn" : "edit-ap-btn"

    this.unEnrollModalOptions = new ModalOptions({
      additionalClasses: `autopay-modal modal-medium modal-dialog modal-center-on-page upload-document-modal`,
      additionalButtonClasses: btnClass + ' ghost secondary x-small-btn manage-ap-btn',
      animatePosition: 'center',
      buttonCopy: (this.action === "unenroll") ? 'Unenroll' : 'Edit',
      modalId: 'endEnrollModal',
      modalTranslateCopy: '',
      typeOfModal: 'default',
      modalName: 'autopay_Unenroll',
    });

    this.modalIcon = this.isAcmic 
                        ? './assets/img/images/unenroll-modal-acmic.svg'
                        : (this.action === "unenroll") ? './assets/img/images/unenroll-modal-ma.svg' : './assets/img/images/edit-icon.svg';
  }

  resetHideModal(): void {
    this.hideModal = !this.hideModal;
  }

  hideModalAction(event): void {
    if (event) {
      this.hideModal = !this.hideModal;
    }
  }

  onUnenroll(): void {
    if(this.policy?.company?.companyName === 'TW'){
         const label = (this.action === "unenroll") ? 'Unenroll from autopay confirm' : 'Unenroll to edit card'
         this.dataLayer.pushManagePolicyEvent(label)
     }
     this.unenrollEvent.emit(true);    
  }

  onKeepEnroll(): void {
     if(this.policy?.company?.companyName === 'TW'){
         const label = (this.action === "unenroll") ? 'Unenroll from autopay cancel' : 'Edit autopay cancel'
         this.dataLayer.pushManagePolicyEvent(label)
     }
  }

  onOpenModal(): void{
     if(this.policy?.company?.companyName === 'TW'){
         const label = (this.action === "unenroll") ? 'Unenroll from autopay' : 'Edit autopay'
         this.dataLayer.pushManagePolicyEvent(label)
     }
  }
}
